import * as React   from 'react';
import PropTypes, { instanceOf }    from 'prop-types';
import RadioContainer from '../input/radio-container';
import CheckboxContainer from '../input/checkbox-container';

export default class CheckboxGroupComponent extends React.Component {
	render() {
		return (
			<div className="form-group">
				<label className="col-sm-2 control-label">{this.props.label}</label>
				<div className="col-sm-10">
					{this.props.children}
				</div>
			</div>
		);
	}
}

CheckboxGroupComponent.propTypes = {
	children: (props, propName, componentName) => {
		const prop                  = props[propName];
		const propIsArray           = Array.isArray(prop);
		const propIsComponent       = !!prop.type;
		const propIsCheckboxOrRadio = RadioContainer === prop.type || CheckboxContainer === prop.type;

		let errorMessage = `Invalid prop ${propName} supplied to ${componentName}.\n`;
		errorMessage += `Expected an array of CheckboxContainer and/or RadioContainer components, `;
		errorMessage += `or a single CheckboxContainer component or a single RadioContainer component, `;

		if (!propIsArray && (!propIsComponent || !propIsCheckboxOrRadio)) {
			errorMessage += `but one ${prop.type.name} component given.`;
			return new Error(errorMessage);
		} else if (propIsArray) {
			const invalidChild = prop.find(child => {
				const childIsComponent       = !!child.type;
				const childIsCheckboxOrRadio = RadioContainer === child.type || CheckboxContainer === child.type;
				return !childIsComponent || !childIsCheckboxOrRadio;
			});
			
			if (invalidChild) {
				errorMessage += `but an array containing at least one ${invalidChild.type.name} component given.`;
				return new Error(errorMessage);
			}
		}
	},
	label   : PropTypes.string
}


// WEBPACK FOOTER //
// ./src/component/form/checkbox-group/checkbox-group-component.js